import { ReadRequest } from "~/backendApis/foundation/ReadRequest"
import { FileMessageView } from "~/backendApis/viewModel/matching"

interface Params {
  universalCorporationId: string
  chatGroupId: string
  messageId: string
}

export class GetFileMessageByIdReadRequest extends ReadRequest<FileMessageView> {
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public get(): Promise<FileMessageView> {
    return this.apiClient.get(this.makeEndpoint())
  }

  private makeEndpoint(): string {
    const { universalCorporationId, chatGroupId, messageId } = this.params
    return `/matching/corporation_member/${universalCorporationId}/chat_group/${chatGroupId}/file/${messageId}`
  }
}
